import { render, staticRenderFns } from "./App.vue?vue&type=template&id=32c1daae&"
var script = {}
import style0 from "./assets/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports